import { render, staticRenderFns } from "./ReceivedDeliveryItem.vue?vue&type=template&id=cbfeaac0&scoped=true"
import script from "./ReceivedDeliveryItem.vue?vue&type=script&lang=js"
export * from "./ReceivedDeliveryItem.vue?vue&type=script&lang=js"
import style0 from "./ReceivedDeliveryItem.vue?vue&type=style&index=0&id=cbfeaac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfeaac0",
  null
  
)

export default component.exports